import { jsxs as r, jsx as t } from "react/jsx-runtime";
import { TIPS_LENGTH as l } from "../constants/tips.js";
const o = ({ step: i }) => /* @__PURE__ */ r("div", { className: "bullets-container", children: [
  /* @__PURE__ */ t(e, { isActive: i === 1 }),
  /* @__PURE__ */ t(e, { isActive: i > 1 && i < l }),
  /* @__PURE__ */ t(e, { isActive: i === l })
] }), e = ({ isActive: i }) => /* @__PURE__ */ t("div", { className: `bullet ${i ? "active" : ""}` });
export {
  o as Bullets
};
